/** Validate display getters when decoding, then retain them for language changes on cached views. */
export function validatedDisplayView<const View extends object>(view: View): View {
  for (const descriptor of Object.values(Object.getOwnPropertyDescriptors(view))) {
    if (descriptor.get !== undefined) descriptor.get.call(view);
  }
  return view;
}

/** Extend a decoded view without object spread freezing its display getters in one language. */
type ExtendedView<Base, Addition> = Base extends object ? Omit<Base, keyof Addition> & Addition : never;
export function extendDisplayView<const Base extends object, const Addition extends object>(base: Base, addition: Addition): ExtendedView<Base, Addition> {
  return Object.defineProperties({}, {
    ...Object.getOwnPropertyDescriptors(base),
    ...Object.getOwnPropertyDescriptors(addition),
  }) as ExtendedView<Base, Addition>;
}
